module.exports = __webpack_public_path__ + "img/Export-Black.9a14b6a7.svg";